module.exports = __webpack_public_path__ + "static/fonts/Avenir-Medium.a1a59db.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Avenir/Avenir-Medium.ttf
// module id = gSNE
// module chunks = 0